import { CheckRounded } from "@mui/icons-material";
import { Stack, ToggleButton, Typography } from "@mui/material";
import { StatusIcon } from "src/components";
import { IStatus } from "src/constants";

interface Props {
  status: IStatus;
  selected: boolean;
}

const StatusToggleButton = (props: Props) => {
  return (
    <ToggleButton value={props.status.id}>
      <Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between", width: "100%" }}>
        <Stack direction="row" spacing={0.5} sx={{
          alignItems: "baseline"
        }}>
          <StatusIcon status={props.status} sx={{ alignSelf: "center" }} />
          <Typography>{props.status.name}</Typography>
        </Stack>
        {props.selected && <CheckRounded />}
      </Stack>
    </ToggleButton>
  );
};

export { StatusToggleButton };
